"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var tooltip_1 = tslib_1.__importDefault(require("../../../../ui-components/tooltip/tooltip"));
var inline_icon_1 = tslib_1.__importDefault(require("../../../../ui-components/inline-icon/inline-icon"));
var EmbedIcon_1 = tslib_1.__importDefault(require("../../../../../icons/compiled/components/EmbedIcon"));
var styles_scss_1 = tslib_1.__importDefault(require("../styles.scss"));
var styles_scss_2 = tslib_1.__importDefault(require("./styles.scss"));
var EmbedButton = /** @class */ (function (_super) {
    tslib_1.__extends(EmbedButton, _super);
    function EmbedButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.props.onClick();
        };
        return _this;
    }
    EmbedButton.prototype.render = function () {
        var _a = this.props, dataHook = _a.dataHook, className = _a.className, ariaLabel = _a.ariaLabel, disabled = _a.disabled, tooltip = _a.tooltip;
        return (react_1.default.createElement(tooltip_1.default, { content: tooltip },
            react_1.default.createElement("button", { "data-hook": dataHook, className: "".concat(styles_scss_2.default.icon, " ").concat(className), "aria-hidden": disabled, disabled: disabled, onClick: this.handleClick, "aria-label": ariaLabel },
                react_1.default.createElement(inline_icon_1.default, { className: "".concat(styles_scss_1.default.icon, " ").concat(styles_scss_2.default.icon), icon: react_1.default.createElement(EmbedIcon_1.default, null) }))));
    };
    return EmbedButton;
}(react_1.default.Component));
EmbedButton.propTypes = {
    dataHook: prop_types_1.default.string,
    className: prop_types_1.default.string,
    tooltip: prop_types_1.default.node,
    onClick: prop_types_1.default.func,
    ariaLabel: prop_types_1.default.string,
    disabled: prop_types_1.default.bool,
};
exports.default = EmbedButton;
//# sourceMappingURL=embed-button.js.map